import { Form, Field, Dropdown } from '@carboledger/ui';
import { useTranslations } from '@/hooks';

const FIELDS = [
  { name: 'foodSecurityStandard', labelKey: 'FORM_FOOD_SECURITY_STANDARD' },
  { name: 'euDeforestationRegulation', labelKey: 'FORM_EU_DEFORESTATION_REGULATION' },
  { name: 'nonGmoFoodFeed', labelKey: 'FORM_NON_GMO_FOOD_FEED' },
  { name: 'nonGmoTechnicalMarkets', labelKey: 'FORM_NON_GMO_TECHNICAL_MARKETS' },
];

/**
 * Props:
 *   formOptions  useValidateDeclarationFormOptions() result
 */
export const VoluntaryAddOnsSection = ({ formOptions }) => {
  const t = useTranslations();

  return (
    <Form.Section title={t('SECTION_VOLUNTARY_ADD_ONS')}>
      {FIELDS.map(({ name, labelKey }) => (
        <Form.Row key={name} columns={1}>
          <AddOnField name={name} labelKey={labelKey} options={formOptions.yesNoOptions} />
        </Form.Row>
      ))}
    </Form.Section>
  );
};

const AddOnField = ({ name, labelKey, options }) => {
  const t = useTranslations();
  return (
    <Field name={name}>
      {({ id, value, onChange, onBlur, status, message }) => (
        <Dropdown
          id={id}
          name={name}
          label={t(labelKey)}
          placeholder={t('COMMON_SELECT')}
          value={value}
          onChange={onChange}
          onBlur={onBlur}
          status={status}
          message={message}
          options={options}
        />
      )}
    </Field>
  );
};
